module.exports = __webpack_public_path__ + "img/doctors.b7c971f7.svg";